module.exports = __webpack_public_path__ + "media/images/icons/uzemniPlanovani-a51b35b1490282312577f103c9ee2d9e.svg";